import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=b8429bbc&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=b8429bbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8429bbc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b8429bbc')) {
      api.createRecord('b8429bbc', component.options)
    } else {
      api.reload('b8429bbc', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=b8429bbc&scoped=true&", function () {
      api.rerender('b8429bbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2yKOn6QKw6xUf/JS/comp/SearchFilterTokens.vue"
export default component.exports